import type { FaireProductEntity } from "../../entity_types/product";

export const p_4vkryvpsfx: FaireProductEntity = {
  token: "p_4vkryvpsfx",
  type: "product",
  name: "LANALIN - Chic Printed Sandals, Faux Chain & Toe Strap",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/e5b97027c3809a6c21467711c9c3b246617e5d8939e3bfbf49e7be9041781a02.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eebb5301a4a1d696153e1fc85fa25400d0f75ea6c4f62b46f0a401cbd62012c8.jpeg",
    "https://cdn.faire.com/fastly/356d8596fce181a98eb289f9e9ee90d401f30ed651c37134282108134eb45d0b.jpeg",
    "https://cdn.faire.com/fastly/1d75a2513d6175b96bfdeffdb4fad2bfebe7a7bd4819939c57365f1a0f46cb7d.jpeg",
    "https://cdn.faire.com/fastly/91e5a23cffddfb59b98882a932e6c13112979171fa4ba7e8b0c4aa4da8e16abc.jpeg",
  ],
  priceDollars: 11.75,
  description:
    "Product Description\nThese statement sandals feature a sculptural faux chain strap, polished gold-tone toe ring, and sleek low heel for an elevated finish. From timeless polka dots to playful abstract prints, each colorway brings its own personality while keeping the silhouette effortlessly chic. Perfect for adding a fashion-forward touch to warm-weather looks.\nOOTD\nPair them with linen trousers and a fitted tank for an elevated daytime outfit, or style them with a satin midi skirt and a simple cami for dinner by the beach. They also look effortlessly cool with denim shorts, a crisp button-down, and gold jewelry to complement the metallic hardware.",
  tags: [],
  msrpDollars: 23.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:11.563Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
